function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1 3.7451C1 2.22902 2.22902 1 3.7451 1H8.2549C9.77098 1 11 2.22902 11 3.7451V11.2549C11 12.771 9.77098 14 8.2549 14H3.7451C2.22902 14 1 12.771 1 11.2549V3.7451Z",
  fill: "#738BA5"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.2549 2.41177H3.7451C3.00872 2.41177 2.41176 3.00872 2.41176 3.7451V11.2549C2.41176 11.9913 3.00872 12.5882 3.7451 12.5882H8.2549C8.99128 12.5882 9.58823 11.9913 9.58823 11.2549V3.7451C9.58823 3.00872 8.99128 2.41177 8.2549 2.41177ZM3.7451 1C2.22902 1 1 2.22902 1 3.7451V11.2549C1 12.771 2.22902 14 3.7451 14H8.2549C9.77098 14 11 12.771 11 11.2549V3.7451C11 2.22902 9.77098 1 8.2549 1H3.7451Z",
  fill: "#738BA5"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M1 18.7451C1 17.229 2.22902 16 3.7451 16H8.2549C9.77098 16 11 17.229 11 18.7451V20.2549C11 21.771 9.77098 23 8.2549 23H3.7451C2.22902 23 1 21.771 1 20.2549V18.7451Z",
  fill: "#738BA5"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.2549 17.4118H3.7451C3.00872 17.4118 2.41176 18.0087 2.41176 18.7451V20.2549C2.41176 20.9913 3.00872 21.5882 3.7451 21.5882H8.2549C8.99128 21.5882 9.58823 20.9913 9.58823 20.2549V18.7451C9.58823 18.0087 8.99128 17.4118 8.2549 17.4118ZM3.7451 16C2.22902 16 1 17.229 1 18.7451V20.2549C1 21.771 2.22902 23 3.7451 23H8.2549C9.77098 23 11 21.771 11 20.2549V18.7451C11 17.229 9.77098 16 8.2549 16H3.7451Z",
  fill: "#738BA5"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M23 20.2549C23 21.771 21.771 23 20.2549 23H15.7451C14.229 23 13 21.771 13 20.2549V12.7451C13 11.229 14.229 10 15.7451 10L20.2549 10C21.771 10 23 11.229 23 12.7451V20.2549Z",
  fill: "#738BA5"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.7451 21.5882H20.2549C20.9913 21.5882 21.5882 20.9913 21.5882 20.2549V12.7451C21.5882 12.0087 20.9913 11.4118 20.2549 11.4118H15.7451C15.0087 11.4118 14.4118 12.0087 14.4118 12.7451V20.2549C14.4118 20.9913 15.0087 21.5882 15.7451 21.5882ZM20.2549 23C21.771 23 23 21.771 23 20.2549V12.7451C23 11.229 21.771 10 20.2549 10L15.7451 10C14.229 10 13 11.229 13 12.7451V20.2549C13 21.771 14.229 23 15.7451 23H20.2549Z",
  fill: "#738BA5"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M23 5.2549C23 6.77098 21.771 8 20.2549 8L15.7451 8C14.229 8 13 6.77098 13 5.2549V3.7451C13 2.22902 14.229 1 15.7451 1L20.2549 1C21.771 1 23 2.22902 23 3.7451V5.2549Z",
  fill: "#738BA5"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.7451 6.58823L20.2549 6.58824C20.9913 6.58824 21.5882 5.99128 21.5882 5.2549V3.7451C21.5882 3.00872 20.9913 2.41177 20.2549 2.41177L15.7451 2.41176C15.0087 2.41176 14.4118 3.00872 14.4118 3.7451V5.2549C14.4118 5.99128 15.0087 6.58823 15.7451 6.58823ZM20.2549 8C21.771 8 23 6.77098 23 5.2549V3.7451C23 2.22902 21.771 1 20.2549 1L15.7451 1C14.229 1 13 2.22902 13 3.7451V5.2549C13 6.77098 14.229 8 15.7451 8L20.2549 8Z",
  fill: "#738BA5"
});

function SvgDashboardIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/DashboardIcon.0dc8475f.svg";
export { ForwardRef as ReactComponent };